angular.module("ainapp")
    .controller("conflictedLedgersController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Conflicted Ledgers";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {

            
            }
            $scope.Init();

             $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        MainService.GerWrongLedgerRecords().then(function (response) {
                            o.success({
                                Data:response.data
                            });
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            VoucherNo: {
                                type: "string",
                                editable: false,
                            },
                            Date: {
                                type: "date",
                                editable: false,
                            },
                            Type: {
                                type: "string",
                                editable: false,
                            },
                            TotalDebit: {
                                type: "number",
                                editable: false,
                            },
                            TotalCredit: {
                                type: "number",
                                editable: false,
                            },
                            Difference: {
                                type: "number",
                                editable: false,
                            },
                        }
                    }
                },
                serverPaging: false,
                serverSorting: false,
                serverFiltering: false,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {



                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },



                columns: [
                    
                    {
                        field: "VoucherNo",
                        title: "Voucher No",
                        },
                    {
                        field: "Date",
                        title: "Date",
                        template:"<p>{{dataItem.Date | date:'dd/MM/yyyy'}}</p>"
                        },
                    {
                        field: "Type",
                        title: "Type",
                        },
                    {
                        field: "TotalDebit",
                        title: "Total Debit",
                        },
                    {
                        field: "TotalCredit",
                        title: "Total Credit",
                        },
                    {
                        field: "Difference",
                        title: "Difference.",
                        }]

            };





        }])
